export default __webpack_public_path__ + "static/media/user-img.4d494e0a.webp";